var _defs, _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconesiscap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 692.2 716.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #5a81f9;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #5b82f9;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #aec5fe;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 406.5,
    cy: 228.6,
    r: 114.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.4,409.1l4.7-7c149.8-15.4,369-20,465.9,118.2,73.8,105.3,15.1,218.2-116.2,193.1-81.9-15.6-198.5-107-251.7-170.3s-66.8-91.7-102.7-134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194,402.1l-4.7,7c-51.4-14-96-9.7-137.6-47.8S-9.7,255.7,6.8,192.8c17.2-65.3,73.7-93.5,119.2-31.6,41.1,56,38.3,126.2,52.4,190.1,3.9,17.7,10,33.8,15.6,50.9Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131,
    cy: 54.1,
    r: 54.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesiscap);
export default __webpack_public_path__ + "static/media/Icone siscap.7242b2606c1d23dae1550af812a0ee1c.svg";
export { ForwardRef as ReactComponent };